export default __webpack_public_path__ + "static/logo-10fde6396cc9ecfc3e4e0e3f73b2a653.svg";